<p-toast position="top-right" key="show"></p-toast>
<p-toast position="top-right"></p-toast>

<ng-container *ngIf="loader">
  <app-loading [loaderHeight]="'medium'"> </app-loading>
</ng-container>

<!-- Device List View -->
<div *ngIf="isShowDeviceList && !loader && !showRegistrationForm">
  <div class="modal-header d-flex justify-content-between">
    <div class="row thumbs_icon">
      <div class="ml-2">
        <h5 class="modal-title" id="exampleModalLongTitle">
          <span class="font-weight-bold text_baseline">{{ 'passkey.registerDevice' | translate }}</span>
        </h5>
      </div>
    </div>
     <button type="button" class="close" (click)="close()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="forms-sample ml-3 mr-3">
    <div class="device-list-container">
      <div class="device-list-content">
        <div *ngIf="isLoading" class="loading-container">
          <app-loading [loaderHeight]="'small'"> </app-loading>
        </div>

        <div *ngIf="!isLoading && error" class="error-container">
          <div class="alert alert-danger" role="alert">
            <i class="fas fa-exclamation-triangle me-2"></i>
            {{ error }}
          </div>
          <button class="btn btn-outline-primary" (click)="loadUserDevices()">
            <i class="fas fa-redo me-2"></i>Retry
          </button>
        </div>

        <div *ngIf="!isLoading && !error && devices.length === 0" class="no-devices-container">
          <div class="text-center py-4">
            <i class="fas fa-fingerprint fa-3x text-muted mb-3"></i>
            <h5 class="text-muted">No devices registered</h5>
            <p class="text-muted">You haven't registered any devices for fingerprint authentication yet.</p>
            <button class="btn btn-primary" (click)="showRegistrationFormForNewDevice()">
              <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <i class="fas fa-plus me-2"></i> {{'passkey.registerNewDevice' | translate}}
            </button>
          </div>
        </div>

        <div *ngIf="!isLoading && !error && devices.length > 0" class="devices-grid">
          <!-- Current Device Already Registered Message -->
          <div *ngIf="!isLoading && !error && devices.length > 0 && isCurrentDeviceRegistered && hideMessage">
            <div class="alert alert-info text-center" role="alert">
              <strong>{{'passkey.alreadyregister' | translate}}</strong>
              <p class="mb-0 mt-2">{{'passkey.altrRegMeg' | translate}}</p>
            </div>
          </div>
          <div *ngFor="let device of devices" class="device-card">
            <div class="device-info">
              <div class="device-icon">
                <i [class]="getDeviceIcon(device.deviceInfo)"></i>
              </div>
              <div class="device-details">
                <h6 class="device-name">{{ getDeviceDisplayName(device.deviceInfo) }}</h6>
                <p class="device-meta text-muted">
                  <small>
                    <i class="fas fa-key me-1"></i>
                    {{ getDeviceDisplayId(device) }}
                  </small>
                </p>
                <p class="device-meta text-muted">
                  <small>
                    <i class="fas fa-calendar-alt me-1"></i>
                    {{'passkey.registerText' | translate}}: {{ formatDate(device.createdAt) }}
                  </small>
                </p>
                <p class="device-meta text-muted">
                  <small>
                    <i class="fas fa-clock me-1"></i>
                    {{'passkey.lastUsedText' | translate}}: {{ formatDate(device.lastUsedAt) }}
                  </small>
                </p>

              </div>
            </div>
            <div class="delete-btn float-right align-items-end justify-content-end d-flex">
                  <button (click)="deleteDevice(device.id)" class="btn btn-danger btn-icon">
                     <span *ngIf="deletingDeviceId === device.id" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <i *ngIf="deletingDeviceId !== device.id" class="link-icon feather icon-trash"></i></button>
                </div>
          </div>
        </div>

        <!-- Add New Device Button - Only show if current device is NOT registered -->
          <div *ngIf="!isLoading && !error && devices.length > 0 && !isCurrentDeviceRegistered" class="card-footer pb-2 d-flex flex-row-reverse gap-flex text-center">
            <button class="btn btn-primary btn-block mb-3" (click)="showRegistrationFormForNewDevice()">
              <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <i class="fas fa-plus me-2"></i> {{'passkey.registerNewDevice' | translate}}
            </button>
          </div>
      </div>
    </div>
  </div>
</div>

<!-- Registration Form View -->

<div *ngIf="showRegistrationForm && !loader">
  <div class="modal-header d-flex justify-content-between">
    <div class="row thumbs_icon">
      <div class="ml-2">
        <h5 class="modal-title" id="exampleModalLongTitle">
          <span class="font-weight-bold text_baseline">{{'passkey.setUp' | translate}}</span>
        </h5>
      </div>
    </div>
    <button type="button" class="close" (click)="close()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div>
    <div class="modal-body text-center p-3" *ngIf="!isMfaEnabled">
      <div class="alert alert-info">
        <i class="fas fa-info-circle"></i>
        <strong>{{'passkey.setUpMeg1' | translate}}</strong>
        <p class="mb-0 mt-2"> {{'passkey.setUpMeg2' | translate}}
        </p>
      </div>
    </div>

    <div class="card-footer pb-2 d-flex flex-row-reverse gap-flex" *ngIf="!isMfaEnabled">
      <button type="button" class="btn btn-primary btn-block mb-3" (click)="registerFingerprint()">
        <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span class="loader_ml">{{ 'passkey.registerPasskey' | translate }}</span>
      </button>
    </div>

    <!-- Back to Device List Button -->
    <div class="text-center mb-3" *ngIf="!isMfaEnabled && !isShowDeviceList && devices.length > 0">
      <button type="button" class="btn btn-light" (click)="backToDeviceList()" [disabled]="isLoading" >
        <i class="link-icon feather skip-back mr-2"></i> {{'passkey.back' | translate}}
      </button>
    </div>
  </div>
</div>

<!-- MFA Component -->
<app-multi-factor-auth *ngIf="isMfaEnabled" 
  widthClass="col-md-12 col-xl-12"
  (afterSuccessVerifyOtp)="afterSuccessVerifyOtp($event)" 
  (onError)="onError($event)" 
  native="component"
  [mfaData]="mfaData" 
  [apiName]="apiName" 
  [formData]="formData" 
  [title]="mfaTitle" 
  [content]="mfaContent"
  [showBackButton]="true" 
  (onBack)="onBack($event)" 
  [isFullWidth]="true">
</app-multi-factor-auth>
